import React from 'react';
import classnames from 'classnames';
import PairOfCards from '../../../../components/PairOfCards';
import './QuizzesList.scss';
import BrowserLink from '../../../../components/BrowserLink';

export function QuizzesList({
  className,
  list,
  ...props
}) {

  return (
    <ul className={classnames('QuizzesList', className)} {...props}>
      {list.map(({ cards, type, stack, position, url }) => (
        <li className="QuizzesList__item" key={url}>
          <BrowserLink
            href={url}
            className="QuizzesList__item-link"
          >
            <PairOfCards cards={cards} className="QuizzesList__item-cards" />
            <span className="QuizzesList__item-meta">{type}</span>
            <span className="QuizzesList__item-meta">{stack}</span>
            <span className="QuizzesList__item-meta">{position}</span>
          </BrowserLink>
        </li>
      ))}
    </ul>
  );
}
